// extracted by mini-css-extract-plugin
export default {"liveContainer":"LiveEmbed_liveContainer__PevZf","someContent":"LiveEmbed_someContent__3gCgj"};